import React from "react";
import "../../assets/Style.css";


const industryData = [
  {
    columnClass: "industries-col-offset-1",
    items: [
      { img: process.env.PUBLIC_URL + "/images/ind-11.png", label: "Real Estate" },
      { img: process.env.PUBLIC_URL + "/images/ind-11.png", label: "Law" },
    ],
  },
  {
    columnClass: "",
    items: [
      { img: process.env.PUBLIC_URL + "/images/ind-1.png", label: "Import-Export" },
      { img: process.env.PUBLIC_URL + "/images/ind-8.png", label: "Donation" },
      { img: process.env.PUBLIC_URL + "/images/ind-2.png", label: "Travel" },
    ],
  },
  {
    columnClass: "industries-col-offset-2",
    items: [
      { img: process.env.PUBLIC_URL + "/images/ind-6.png", label: "Beauty care" },
      { img: process.env.PUBLIC_URL + "/images/ind-9.png", label: "E-commerce" },
    ],
  },
  {
    columnClass: "",
    items: [
      { img: process.env.PUBLIC_URL + "/images/ind-10.png", label: "Education" },
      { img: process.env.PUBLIC_URL + "/images/ind-12.png", label: "Medical" },
      { img: process.env.PUBLIC_URL + "/images/ind-4.png", label: "Dental" },
    ],
  },
  {
    columnClass: "industries-col-offset-3",
    items: [
      { img: process.env.PUBLIC_URL + "/images/ind-5.png", label: "Fintech" },
      { img: process.env.PUBLIC_URL + "/images/ind-7.png", label: "Nature" },
    ],
  },
];
export default function Grow() {
  return (
    <div className="industries-container">
      <h3 style={{ textAlign: "center" }}>Industries We Serve</h3>
      <p style={{ textAlign: "center", paddingTop: "10px" }}>
        Whether you're a startup or a global enterprise, we combine <br />
        tech expertise with industry insight to help your business grow
      </p>

      <div className="industries-grid">
        {industryData.map((column, colIndex) => (
          <div
            className={`industries-column ${column.columnClass}`}
            key={colIndex}
          >
            {column.items.map((item, index) => (
              <div className="industry-card" key={index}>
                <img
                  src={item.img}
                  className="industry-icon"
                  alt={item.label}
                />
                <h4 style={{ textAlign: "center" }}>{item.label}</h4>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
